'use client';
import React from 'react';
import { PopperProps } from '@mui/material';
import Popper from '@mui/material/Popper';

export const SearchFormPickersPopperComponent = ({ children, ...props }: PopperProps) => <Popper {...props}>{children}</Popper>;
